import { Achievement } from '../types/game';

export const achievements: Achievement[] = [
  {
    id: 'achievement-1',
    title: 'First Steps',
    description: 'Complete your first life decision',
    icon: '👶',
    color: '#fbbf24',
    unlocked: false,
    requirements: {
      decisions: ['decision-1'],
    },
  },
  {
    id: 'achievement-2',
    title: 'Scholar',
    description: 'Achieve high education level',
    icon: '🎓',
    color: '#8b5cf6',
    unlocked: false,
    requirements: {
      stats: { education: 80 },
    },
  },
  {
    id: 'achievement-3',
    title: 'Wealthy',
    description: 'Accumulate significant wealth',
    icon: '💰',
    color: '#10b981',
    unlocked: false,
    requirements: {
      stats: { wealth: 85 },
    },
  },
  {
    id: 'achievement-4',
    title: 'Healthy Living',
    description: 'Maintain excellent health',
    icon: '💪',
    color: '#ef4444',
    unlocked: false,
    requirements: {
      stats: { health: 90 },
    },
  },
  {
    id: 'achievement-5',
    title: 'Social Butterfly',
    description: 'Build strong relationships',
    icon: '🦋',
    color: '#ec4899',
    unlocked: false,
    requirements: {
      stats: { relationships: 85 },
    },
  },
  {
    id: 'achievement-6',
    title: 'Career Master',
    description: 'Reach the top of your career',
    icon: '👑',
    color: '#3b82f6',
    unlocked: false,
    requirements: {
      stats: { career: 90 },
    },
  },
  {
    id: 'achievement-7',
    title: 'Balanced Life',
    description: 'Maintain balance across all areas',
    icon: '⚖️',
    color: '#f59e0b',
    unlocked: false,
    requirements: {
      stats: { health: 70, happiness: 70, wealth: 70, relationships: 70, education: 70, career: 70 },
    },
  },
  {
    id: 'achievement-8',
    title: 'Life Learner',
    description: 'Complete 10 major decisions',
    icon: '📚',
    color: '#8b5cf6',
    unlocked: false,
    requirements: {
      decisions: ['decision-1', 'decision-2', 'decision-3', 'decision-4', 'decision-5', 'decision-6', 'decision-7', 'decision-8', 'decision-9', 'decision-10'],
    },
  },
  {
    id: 'achievement-9',
    title: 'Golden Years',
    description: 'Reach senior age with high satisfaction',
    icon: '🌅',
    color: '#f59e0b',
    unlocked: false,
    requirements: {
      age: 65,
      stats: { happiness: 80 },
    },
  },
  {
    id: 'achievement-10',
    title: 'Perfect Score',
    description: 'Achieve maximum score',
    icon: '🏆',
    color: '#ffd700',
    unlocked: false,
    requirements: {
      stats: { health: 95, happiness: 95, wealth: 95, relationships: 95, education: 95, career: 95 },
    },
  },
];
